import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Candidate|Eligibilities|';
const sharedProperties: Pick<LocDef, 'feature' | 'portal'> = {
	feature: HubFeature.ExamAuthorization,
	portal: 'SP',
};

type LocNameStart = 'SPEligibilities';
export type SPEligibilitiesLocNames =
	| `${LocNameStart}FilterValueNone`
	| `${LocNameStart}FilterValueSome`
	| `${LocNameStart}TitleAvailableSection`
	| `${LocNameStart}TitleFutureSection`
	| `${LocNameStart}TitleExpiredSection`;

export const spEligibilitiesLocs: LocDefs<SPEligibilitiesLocNames> = {
	SPEligibilitiesFilterValueNone: {
		defaultValue: 'Not Sent',
		description: 'Filter label for when no providers have pushed',
		displayPath: `${dpRoot}Filter Value None`,
		displayType: 'Content',
		htmlAllowed: false,
		legacyName: 'Exam.Authorization/Candidates.Eligibilities.Content.FilterValueNone',
		...sharedProperties,
	},
	SPEligibilitiesFilterValueSome: {
		defaultValue: 'Sent',
		description: 'Filter label for when some providers have pushed',
		displayPath: `${dpRoot}Filter Value Some`,
		displayType: 'Content',
		htmlAllowed: false,
		legacyName: 'Exam.Authorization/Candidates.Eligibilities.Content.FilterValueSome',
		...sharedProperties,
	},
	SPEligibilitiesTitleAvailableSection: {
		defaultValue: 'Eligibilities',
		description: 'The section title for current eligibilities',
		displayPath: `${dpRoot}Available Section Title`,
		displayType: 'Title',
		legacyName: 'Exam.Authorization/Candidates.Eligibilities.Title.AvailableSection',
		...sharedProperties,
	},
	SPEligibilitiesTitleFutureSection: {
		defaultValue: 'Future Eligibilities',
		description: 'The section title for future eligibilities',
		displayPath: `${dpRoot}Future Section Title`,
		displayType: 'Title',
		legacyName: 'Exam.Authorization/Candidates.Eligibilities.Title.FutureSection',
		...sharedProperties,
	},
	SPEligibilitiesTitleExpiredSection: {
		defaultValue: 'Expired Eligibilities',
		description: 'The section title for expired eligibilities',
		displayPath: `${dpRoot}Expired Section Title`,
		displayType: 'Title',
		legacyName: 'Exam.Authorization/Candidates.Eligibilities.Title.ExpiredSection',
		...sharedProperties,
	},
};

export const LOC_KEYS = MapLocKeys<SPEligibilitiesLocNames>(spEligibilitiesLocs);
